import { getApiURL, getSessionId } from 'utils/utils';
import axios from 'axios';

const instance = axios.create({
  // baseURL: 'http://localhost:9781',
  baseURL: getApiURL(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});
export const listCycles = () =>
  instance.post(`/web-app/admin/cycles/list`, undefined, {
    headers: {
      sessionId: getSessionId(),
    },
  });

//name, modules, participants
export const createCycle = (params) =>
  instance.post(`/web-app/admin/cycles/create`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

export const getCycleDetails = (id) =>
  instance.post(
    `/web-app/admin/cycles/get-by-id`,
    { cycleId: id },
    {
      headers: {
        sessionId: getSessionId(),
      },
    }
  );

export const updateCycle = (params) =>
  instance.post(`/web-app/admin/cycles/update`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

// /toggle-isArchived
export const toggleCycleArchived = (params) =>
  instance.post(`/web-app/admin/cycles/toggle-isArchived`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

export const getCycleParticipants = (params) =>
  instance.post(`/web-app/admin/cycles/participants`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

export const addParticipantsToCycle = (params) =>
  instance.post(`/web-app/admin/cycles/participants/add`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });
export const updateParticipantInCycle = (params) =>
  instance.post(`/web-app/admin/cycles/participants/update`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

export const bulkAddParticipantsToCycle = (params) =>
  instance.post(`/web-app/admin/cycles/participants/bulk-add`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

export const removeParticipantsFromCycle = (params) =>
  instance.post(`/web-app/admin/cycles/participants/remove`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

export const updateCycleStatus = (params) =>
  instance.post(`/web-app/admin/cycles/update-status`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

// list reviews
export const listReviews = (params) =>
  instance.post(`/web-app/admin/cycles/reviews/list`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

// getreview by id
export const getReviewById = (params) =>
  instance.post(`/web-app/admin/cycles/reviews/get-by-id`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

//download results
export const exportReviews = (cycleId) =>
  instance.get(
    `/web-app/admin/cycles/downloads/reviews?cycleId=${cycleId}&sessionid=${getSessionId()}`,
    { responseType: 'blob' }
  );

// /release-reviewee
// body('cycleId').isMongoId(),
//   body('revieweeId').isMongoId(),
//   body('force').isBoolean().optional(),

export const releaseReviewee = (params) =>
  instance.post(`/web-app/admin/cycles/release-reviewee`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

export const releaseReview = (params) =>
  instance.post(`/web-app/admin/cycles/reviews/release`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

export const releaseAllReviews = (params) =>
  instance.post(`/web-app/admin/cycles/reviews/release-all`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });

// /list-my-reviewees
export const listMyReviewees = (params) =>
  instance.post(`/web-app/user/cycles/list-my-reviewees`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });
